import './DataTableV2ColumnsList.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var columnNameCSS = '_1tbe6l33-2-0-1';
export var columnVisibilityCheckboxCSS = _7a468({defaultClassName:'_1tbe6l30-2-0-1',variantClassNames:{isChild:{true:'_1tbe6l31-2-0-1',false:'_1tbe6l32-2-0-1'}},defaultVariants:{},compoundVariants:[]});
export var noItemsFoundCSS = '_1tbe6l34-2-0-1';